export default "__VITE_ASSET__D1N4E0Xq__"